export default __webpack_public_path__ + "assets/images/918c1f573a5362af4896766e161e1b83.svg";